/**
 * One key per upload attempt (`docs/tech-stack.md` §2: "The browser creates an upload
 * idempotency key before sending the image. It keeps retrying the same upload until the API
 * returns the durable note ID."). Must match the backend's pattern
 * `^[A-Za-z0-9._:-]{8,200}$` (`backend/app/models/note.py`); a fixed prefix plus a UUID
 * comfortably fits both the character set and the length bounds, and makes a key
 * unmistakably ours if it ever shows up in a log line.
 */
export function generateIdempotencyKey(): string {
  return `capture-${crypto.randomUUID()}`;
}
